<template>
    <b-link @click="upload_photo_id"> Upload Photo ID </b-link>
  </template>
  
  <script>
  export default {
    methods: {
      upload_photo_id() {
        this.$router.push({ path: '/dashboard' });
        this.$store.commit('togglePhotoUploadModal');
      },
    },
  };
  </script>